module.exports = __webpack_public_path__ + "static/media/logo2.13c03980.svg";